module.exports = __webpack_public_path__ + "static/media/portfolio.069d0ffe.png";